<template>
    <div>

      <!-- page header -->
      <page-heading :show="true" pageTitle="COMPLAT-DASHBOARD-TITLE"></page-heading>

    	<!-- show loading indicator -->
    	<loading-indicator :loading="isInitialLoading"></loading-indicator>

    	<template v-if="!isInitialLoading">

            <v-client-table ref="tblDashboard" name="tblDashboard" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tblDashboard noFirstColumn">

                <!-- before table: FILTER OPTIONS -->
                <template slot="beforeTable">

                    <!-- SEARCH -->
                    <!--
                    <form class="control has-addons is-pulled-left" @submit.prevent="search()">
                        <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                        <span class="button is-info" @click="search()">
                            <span class="icon is-small"><i class="fa fa-search"></i></span>
                        </span>
                    </form>
                    -->

                    <div class="is-pulled-right">
                        <div class="columns is-marginless filters">

                            <!-- ASSIGNEE -->
                            <div class="column">
                                <form-input label="COMPLAT-DASHBOARD-FILTER-USER" minWidth="200px" maxWidth="300px" inputType="select" :selectAllowEmpty="false" :selectIsDisabled="isDisabled" :selectIsSearchable="true" :selectOptions="users" selectCustomLabel="customLabel" selectFieldName="username" :showLabel="false" :showLabelInOptions="false" v-model="filteredUser" :is-horizontal="false"></form-input>
                            </div>

                            <!-- CHANNELS -->
                            <div class="column">
                                <!-- <form-input label="COMPLAT-DASHBOARD-FILTER-CHANNEL" minWidth="250px" maxWidth="300px" inputType="select" :selectIsSearchable="true" :selectOptions="channels" :showLabelInOptions="false" v-model="filteredChannel" :showLabel="false" :is-horizontal="false"></form-input> -->
                                <form-input label="COMPLAT-DASHBOARD-FILTER-VARIANT" minWidth="250px" maxWidth="300px" inputType="select" :selectIsSearchable="true" :selectOptions="articleVariantTypes" :showLabelInOptions="true" v-model="filteredChannel" :showLabel="false" :is-horizontal="false"></form-input>
                            </div>

                        </div>
                    </div>

                </template>

                <!-- picture -->
                <template slot="teaserImage" slot-scope="props">
                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImage(props.row.teaserImage)" :key="props.row.id"></div>
                </template>

                <!-- type -->
                <template slot="type" slot-scope="props">
                    <lang :labelKey="'COMPLAT-DASHBOARD-TYPE-'+props.row.type"></lang>
                </template>

                <!-- status -->
                <template slot="status" slot-scope="props">
                    <lang :labelKey="'COMPLAT-DASHBOARD-STATUS-'+props.row.status"></lang>
                </template>

                <!-- deadline -->
                <template slot="deadline" slot-scope="props">
                    <template v-if="props.row.deadline != null">
                        {{ formatDate2(props.row.deadline, false) }}
                    </template>
                </template>

                <!-- updated -->
                <template slot="updated" slot-scope="props">

                    <template v-if="props.row.updated != null">
                        {{ formatDate2(props.row.updated) }}
                    </template>
                    <template v-else>
                        --
                    </template>
                </template>

            </v-client-table>

        </template>

    </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');


export default {

	name: 'COMPLAT-DASHBOARD',

    data() {

        return {

            isInitialLoading: false,
            isLoading: false,
            users: [],
            channels: [],

            filteredUser: null,
            filteredChannel: null,

            table: {

                tblColumns: ['teaserImage', 'headline', 'type', 'status', 'deadline', 'updated'],

                tblData: [],

                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: true,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'deadline'
                    },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        teaserImage: function(h) {
                            return <lang labelKey="COMPLAT-DASHBOARD-TBL_HEADER-KEY_VISUAL"></lang>
                        },
                        headline: function(h) {
                            return <lang labelKey="COMPLAT-DASHBOARD-TBL_HEADER-TITLE"></lang>
                        },
                        type: function(h) {
                            return <lang labelKey="COMPLAT-DASHBOARD-TBL_HEADER-VERSION"></lang>
                        },
                        status: function(h) {
                            return <lang labelKey="COMPLAT-DASHBOARD-TBL_HEADER-STATUS"></lang>
                        },
                        deadline: function(h) {
                            return <lang labelKey="COMPLAT-DASHBOARD-TBL_HEADER-DEADLINE"></lang>
                        },
                        updated: function(h) {
                            return <lang labelKey="COMPLAT-DASHBOARD-TBL_HEADER-LAST_UPDATE"></lang>
                        }
                    },


                    sortable: ['headline', 'type', 'status', 'deadline', 'updated'],

                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'Aktuell sind keine zugewiesenen Beiträge für Sie vorhanden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    templates: {

                    },

                    // custom filter functions
                    customFilters: [
                        {
            							name: 'filter',
            							callback: function(row, filter) {

            								// reset filter
            								if(filter == null) {
            									return true;
            								}

                            return row.type.toLowerCase() == filter;

                          }
                        }
                    ],

                }
            }


        }
    },

    created() {

        if(this.activeUser) {
          this.filteredUser = this.activeUser;

          // this.filteredUser.customLabel = this.activeUser.person.fullName;
          this.filteredUser.customLabel = this.activeUser.person.lastname + ' ('+this.activeUser.userRole.name+')';
        }

        this.fetchData();

    },

    mounted() {

      Event.$on('vue-tables.tblDashboard.row-click', function (data) {
          this.$router.push({ name: 'complatContentPoolContent', params: { 'contentID': data.row.articleId, 'tab': data.row.type }})
      }.bind(this));

    },

    computed: {

        isDisabled() {
          if(!this.activeUser) {
            return true;
          }
          return ['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(this.activeUser.userRole.name) == -1;
        },

        articleVariantTypes() {
            return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_TYPES');
        },


    },

    watch: {

        filteredUser(user) {
            let uid = user != null ? user.id : null;
            this.fetchArticles(uid);
        },

        filteredChannel(channel) {
            let string = channel != null ? channel.name.toLowerCase().split(' ').join('_') : null;
            Event.$emit('vue-tables.tblDashboard.filter::filter', string);
        },

    },


    methods: {

      getImage(asset) {

  			if(asset == null) {
  				return '';
  			}

      return this.$config.assets + asset;

	    },


      fetchData() {

  			this.isInitialLoading = true;
  			var self = this;


  			function getUsers() {
  				return self.axios.get(self.$config.api + 'user/byGroup?group=Content%20Pool')
  			}
        function getChannels() {
            return self.axios.get(self.$config.api + 'channel')
        }

  			// make the request
  			this.axios.all([getUsers(), getChannels()])

  				.then(self.axios.spread(function (users, channels) {

            // order users by lastName
  					users.data.user.sort(function (a, b) {

  					  if (a.person.lastname.toLowerCase() < b.person.lastname.toLowerCase()) {
  					    return -1;
  					  }
  					  if (a.person.lastname.toLowerCase() > b.person.lastname.toLowerCase()) {
  					    return 1;
  					  }

  					  return 0;

  					});

            users.data.user.forEach((u) => {
              u.customLabel = u.person.lastname + ' ('+u.userRole.name+')';
            })
            self.users = users.data.user;

            self.fetchArticles(self.activeUser.id);
  					self.isInitialLoading = false;

  				})).catch(function(error) {
  					self.isLoading = false;
  					console.log('Error: ', error.message);
  				});


        },

        fetchArticles(userId) {

            this.isLoading = true;

            this.axios.get(this.$config.api + 'articleVariant/byAssignees?assignees='+userId)
            .then(res => {
                this.table.tblData = res.data;
                this.isLoading = false;
            })

        },

    }

}

</script>


<style scoped>

    .tblDashboard >>> th:first-child {
        width: 150px;
        max-width: 150px;
    }
    .imgWrapper {
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
        width: 80px;
        height: 60px;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }
    .imgWrapper[lazy=loading]  {
        background-size: 30% !important;
    }
    .imgWrapper[lazy=error]  {
        background-image: none !important;
    }

</style>
